export default class Review {
  constructor(
    id: number,
    name: string,
    review: string,
    rating: number,
    image: string
  ) {
    this.id = id;
    this.name = name;
    this.review = review;
    this.rating = rating;
    this.image = image;
  }

  public id: number;

  public name: string;

  public review: string;

  public rating: number;

  public image: string;
}
